<template>
	<inertia-head title="TRC COUPLE CONTENTS" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h3 class="fw-bold text-white mb-2">
						{{
							`${$page.props.app.name} - Couple Contents`
						}}
					</h3>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						TRC Couple Contents List
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">

        <div v-if="contents" class="col-12 mb-6">
			<div v-for="(content,a_index) in contents.data" class="block mb-0 border-bottom" :class="{'border-top':a_index>0}">
				<div class="block-content block-content-full">
					<div class="fw-semibold h4 mb-0">{{content.title}}</div>
					<div class="fs-xs text-muted fst-italic">{{content.posted_date}}</div>
					
					<div class="mt-4" style="padding: 56.25% 0 0 0; position: relative">
						<iframe
							:src="`https://player.vimeo.com/video/${content.vimeo_id}`"
							style="
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
							"
							frameborder="0"
							allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
						></iframe>
					</div>
					<p class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="content.description"></p>
				</div>
			</div>

			<div v-if="contents.last_page>1" class="mt-4">
				<pagination v-if="contents.data.length > 0" :collections="contents"/>
			</div>
		</div>

		<div v-if="contents.data.length == 0" class="col-12 mb-6">
			<div class="block mb-0 border-bottom">
				<div class="block-content block-content-full">
					<p class="h1 text-center m-0">Content is not yet available</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		user 		: Object,
		contents 	: Object,
		flash 		: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

	},
}
</script>
